import type { DropTargetGetFeedback } from '@affine/component';
import type { AffineDNDData } from '@affine/core/types/dnd';

import type { NavigationPanelTreeNodeDropEffect } from '../../tree';

export const organizeChildrenDropEffect: NavigationPanelTreeNodeDropEffect =
  data => {
    if (
      data.treeInstruction?.type === 'reorder-above' ||
      data.treeInstruction?.type === 'reorder-below'
    ) {
      if (
        data.source.data.entity?.type === 'folder' ||
        data.source.data.entity?.type === 'doc'
      ) {
        return 'move';
      }
    } else {
      return; // not supported
    }
    return;
  };

export const organizeRootDropEffect: NavigationPanelTreeNodeDropEffect =
  data => {
    const sourceType = data.source.data.entity?.type;
    if (sourceType === 'folder' || sourceType === 'doc') {
      return 'move';
    }
    return;
  };

/**
 * Check whether the data can be dropped on the empty state of the organize section
 */
export const organizeRootCanDrop = (
  data: DropTargetGetFeedback<AffineDNDData>
) => {
  const type = data.source.data.entity?.type;
  if (!type) {
    return false;
  }
  return type === 'doc' || type === 'folder';
};
